import {IReduxStoreState} from '../../../@interfaces';
import {connect} from 'react-redux';
import AuthLoginForm from '../../../components/_forms/AuthLoginForm';
import {setAccessToken} from '../../../_redux/user/actions';

export default connect(
	(state: IReduxStoreState) => state.user,
	{setAccessToken}
)(AuthLoginForm);
